import React, { Component } from 'react';
import {Topic, TextHolder, Footer, ExploreData} from '../../Components/contentHolders/contentHolders.js';








export class ChapterThirty extends Component {

  render() {
    return (
      <section className="Content">
        <div className="content-holder-topic">
        <div className="content-holder-inner fade">

        <Topic topicNumber={this.props.topicNumber} topicTitle={this.props.topicTitle} topicText={this.props.topicText} />

        <TextHolder text="Looking at the big picture, a few key patterns become clear. Despite being a heterogenous region with different languages and culture, SEA is becoming more integrated. It’s a strong internet market because of its young population, 70 percent of whom are below 40 years old. Nearly 4 million more of those people are going online each year."/>

        <TextHolder text="The top economies within SEA are growing at more than 5 percent a year. Each country might have socio-economic-political challenges, but as a group they are stable; business continues smoothly."/>




        <ExploreData nextChapter={ this.props.nextChapter } />
        <Footer />
        </div>
        </div>
      </section>

    );
  }
}



// WEBPACK FOOTER //
// ./src/Containers/Content/30.js